<div class="slider-container" data-testid="slider-input" [class.slider-checked]="value" [class.slider-disabled]="disabled" (click)="onClickSlider()">
  <span class="slider-ball"></span>
</div>
